import { handleActions } from 'redux-actions'
import {
  LOGIN_HAS_ERRORED,
  LOGIN_IS_LOADING,
  SET_DATA_USUARIO,
  CAMBIAR_CONTRASENIA_IS_LOADING,
  CAMBIAR_CONTRASENIA_HAS_ERRORED,
  CAMBIAR_CONTRASENIA_OK,
  SOLICITAR_CONTRASENIA_IS_LOADING,
  SOLICITAR_CONTRASENIA_HAS_ERRORED,
  ENVIAR_CORREO,
  VERIFICAR_TOKEN_IS_LOADING,
  VERIFICAR_TOKEN_HAS_ERRORED,
  RECUPERAR_CONTRASENIA_OK,
  LIMPIAR_LOGIN,
  LIMPIAR_CAMBIAR_CONTRASENIA,
  LIMPIAR_SOLICITAR_CONTRASENIA,
  LIMPIAR_TOKEN, SET_COUNT_CARRITO, SET_DATA_LEEDS,
  LISTA_COMPRAS_HAS_ERRORED,
  SET_DATA_LISTA_COMPRAS,
  SET_DATA_LISTA_RAMOS,
  LISTA_COMPRAS_LOADING,
  LIMPIAR_DATOS_LISTA_COMPRAS,
  SET_MSG_ERROR_CAMBIO_CONTRASENA,
  setAutenticarOkta,
  setOktaIsLoading,
  setOktaHasError
} from "../actions/aLogin";
import { dataUsuarioVacio } from "../../constants"

export function countCarrito(state = "", action) {
  switch (action.type) {
    case SET_COUNT_CARRITO:
      return action.countCarrito;
    default:
      return state;
  }
}

export function dataLeeds(state = {}, action) {
  switch (action.type) {
    case SET_DATA_LEEDS:
      return action.payload;
    default:
      return state;
  }
}

export const datosUsuarios = (state = { loginIsLoading: false, loginHasError: false, dataUsuario: dataUsuarioVacio }, action) => {
  switch (action.type) {
    case LOGIN_HAS_ERRORED:
      return {
        ...state,
        loginIsLoading: false,
        loginHasError: true
      };
    case LOGIN_IS_LOADING:
      return {
        ...state,
        loginIsLoading: true,
        loginHasError: false
      };
    case SET_DATA_USUARIO:
      return {
        ...state,
        loginIsLoading: false,
        registroIsLoading: false,
        dataUsuario: { ...state.dataUsuario, ...action.payload }
      };
    case LIMPIAR_LOGIN:
      return {
        ...state,
        loginIsLoading: false,
        loginHasError: false,
        dataUsuario: { ...state.dataUsuario, ...dataUsuarioVacio }
      };
    default:
      return state;
  }
};

const initialState = {
  cambiarContraseniaIsLoading: false,
  cambiarContraseniaError: false,
  cambiarContraseniaOK: false,
  msgErrorCambioContrasnia: ""
};
export const datosCambioContrasenia = (state = initialState, action) => {
  switch (action.type) {
    case CAMBIAR_CONTRASENIA_IS_LOADING:
      return {
        ...state,
        cambiarContraseniaIsLoading: true,
        cambiarContraseniaError: false
      };
    case CAMBIAR_CONTRASENIA_HAS_ERRORED:
      return {
        ...state,
        cambiarContraseniaIsLoading: false,
        cambiarContraseniaError: true
      };
    case CAMBIAR_CONTRASENIA_OK:
      return {
        ...state,
        cambiarContraseniaIsLoading: false,
        cambiarContraseniaError: false,
        cambiarContraseniaOK: action.payload
      };
    case LIMPIAR_CAMBIAR_CONTRASENIA:
      return {
        ...state,
        cambiarContraseniaIsLoading: false,
        cambiarContraseniaError: false,
        cambiarContraseniaOK: false,
        msgErrorCambioContrasnia: ""
      };
    case SET_MSG_ERROR_CAMBIO_CONTRASENA:
      return {
        ...state,
        msgErrorCambioContrasnia: action.payload
      };
    default:
      return state;
  }
};

const initialState2 = {
  solicitarContraseniaIsLoading: false,
  solicitarContraseniaError: false,
  enviarCorreo: false
};

export const datosSolicitarContrasenia = (state = initialState2, action) => {
  switch (action.type) {
    case SOLICITAR_CONTRASENIA_IS_LOADING:
      return {
        ...state,
        solicitarContraseniaIsLoading: true,
        solicitarContraseniaError: false
      };
    case SOLICITAR_CONTRASENIA_HAS_ERRORED:
      return {
        ...state,
        solicitarContraseniaIsLoading: false,
        solicitarContraseniaError: true
      };
    case ENVIAR_CORREO:
      return {
        ...state,
        solicitarContraseniaIsLoading: false,
        solicitarContraseniaError: false,
        enviarCorreo: action.payload
      };

    case LIMPIAR_SOLICITAR_CONTRASENIA:
      return {
        ...state,
        solicitarContraseniaIsLoading: false,
        solicitarContraseniaError: false,
        enviarCorreo: false
      };
    default:
      return state;
  }
};

const initialState3 = {
  solicitarContraseniaIsLoading: false,
  solicitarContraseniaError: false,
  enviarCorreo: false
};
export const datosVerificarToken = (state = initialState3, action) => {
  switch (action.type) {
    case VERIFICAR_TOKEN_IS_LOADING:
      return {
        ...state,
        verificarTokenIsLoading: true,
        verificarTokenError: false
      };
    case VERIFICAR_TOKEN_HAS_ERRORED:
      return {
        ...state,
        verificarTokenIsLoading: false,
        verificarTokenError: true
      };
    case RECUPERAR_CONTRASENIA_OK:
      return {
        ...state,
        verificarTokenIsLoading: false,
        verificarTokenError: false,
        recuperarContraseniaOK: action.payload
      };
    case LIMPIAR_TOKEN:
      return {
        ...state,
        verificarTokenIsLoading: false,
        verificarTokenError: false,
        recuperarContraseniaOK: false
      };
    default:
      return state;
  }
};

const initialStateCompras = {
  isLoadingCompras: false,
  hasErroredCompras: false,
  datosCompras: []
};

export function dataCompras(state = initialStateCompras, action) {
  switch (action.type) {
    case LISTA_COMPRAS_LOADING:
      return {
        ...state,
        isLoadingCompras: true,
        hasErroredCompras: false
      };
    case SET_DATA_LISTA_COMPRAS:
      return {
        ...state,
        datosCompras: action.payload,
      };
    case SET_DATA_LISTA_RAMOS:
      return {
        ...state,
        datosFiltro: action.payload,
      };
    case LISTA_COMPRAS_HAS_ERRORED:
      return {
        ...state,
        isLoadingCompras: false,
        hasErroredCompras: true
      };
    case LIMPIAR_DATOS_LISTA_COMPRAS:
      return {
        ...state,
        isLoadingCompras: false,
        hasErroredCompras: false,
        datosCompras: [],
        datosFiltro: []
      };

    default:
      return state;
  }
}


export const rUsuariosOkta = handleActions(
  {
    [setAutenticarOkta]: (state, action) => ({ ...state, oktaIsLoading: false, oktaHasError: false, autenticarOkta: action.payload }),
    [setOktaIsLoading]: (state) => { return { ...state, oktaIsLoading: true, oktaHasError: false }; },
    [setOktaHasError]: (state) => ({ ...state, oktaHasError: true, oktaIsLoading: false, autenticarOkta: [] }),
  },
  {
    autenticarOkta: [],
    oktaIsLoading: false,
    oktaHasError: '',
  }
);